import axios from 'axios'
import { Message } from 'element-ui';
// axios 配置
axios.defaults.timeout = 60000;
axios.defaults.baseURL = process.env.API_PATH;


// http request 拦截器
/*axios.interceptors.request.use(function(config){

  return config;
},function(err){
  return Promise.reject(err);
});*/
// http response 拦截器
axios.interceptors.response.use(function (response) {
  return response;
},function (error) {
    if (error.response) {
        Message.error(error.response.data.message);
        return Promise.reject(error.response.data)
    }else {
      error.response = {};
      Message.error("网络错误，请稍后重试");
      return Promise.reject(error.response.data)
    }
});
export default axios;



// WEBPACK FOOTER //
// ./src/api/http.js